import { render } from "./FriendIconGroup.vue?vue&type=template&id=48e3cbbd&scoped=true"
import script from "./FriendIconGroup.vue?vue&type=script&lang=js"
export * from "./FriendIconGroup.vue?vue&type=script&lang=js"

import "./FriendIconGroup.vue?vue&type=style&index=0&id=48e3cbbd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e3cbbd"]])

export default __exports__